import {View, Sync} from 'MWC';
import tpl from '../templates/detailedNews.jsx';
import {apiback} from '../../../config';
import buildUrl from '../../../helpers/utils/buildGetURLWithParams';

const excellentRate = 'excellent';

export default class extends View {
    template = tpl;

    state = {
        id: this.props.match.params.id,
        article: null,
        textAreaIsOn: false,
        rateContent: '',
        offset: 0,
        limit: 4,
        linkedNews: [],
        raitingNews: '',
        result: false,
        showModal: false,
        isShowPreloader: false
    };

    enableTextArea = () => this.setState({textAreaIsOn: true});
    changeTextArea = ({target: {value}}) => this.setState({rateContent: value});
    clearTextArea = () => this.setState({rateContent: ''});
    sendRate = async () => {
        const Engine = Sync.getEngine('xhr'),
            url = apiback('API_COREZOID'),
            xhr = new Engine({
                url: `${url}`,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: {
                    conv_data: {
                        rateContent: this.state.rateContent,
                        raitingNews: this.state.raitingNews,
                        url: window.location.href
                    },
                    hash: '90SS12F34D7BE9D1'
                },
                cache: false
            });

        try {
            const response = await xhr.post();

            this.setState({result: true});
            this.setState({showModal: true});
            if (response.status !== 'ok') {
                this.setState({result: false});
                throw new Error();
            }
        } catch (error) {
            this.setState({result: false});
            this.setState({showModal: true});
        } finally {
            this.setState({rateContent: ''});
        }
    };

    rateNews = event => {
        const {id} = event.target.parentElement;
        this.setState({raitingNews: id});

        if (id !== excellentRate) {
            this.enableTextArea();
        } else {
            this.clearTextArea();
            this.setState({textAreaIsOn: false}, this.sendRate);
        }
    };

    getArticle = () => {
        this.setState({isShowPreloader: true});

        fetch(`${apiback('API_NEWS')}/${this.state.id}`)
            .then(res => res.json())
            .then(({data}) => this.setState({article: data[0]}))
            .then(() => {
                this.setState({isShowPreloader: false});
            });
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    };

    shouldFilterLinkedNews() {
        return true;
    }

    getLinkedNews = () => {
        const {id, offset, limit} = this.state,
            params = {
                offset,
                limit
            };

        const url = buildUrl(apiback('API_NEWS'), params);

        return fetch(url)
            .then(res => res.json())
            .then(({data}) => {
                let result = data;

                if (this.shouldFilterLinkedNews()) {
                    result = data.filter(article => article.id !== +id);
                }
                this.setState({
                    linkedNews: result.slice(0, 3)
                });
            });
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    };

    toggleModal() {
        this.setState({showModal: !this.state.showModal});
    }

    componentDidMount() {
        this.getArticle();
        this.getLinkedNews();
        this.toggleModal = this.toggleModal.bind(this);
    }
}
